import SquareIconButton from "./SquareIconButton"
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function Logos({ size, gap }) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "row",
        gap
      }}>
        <SquareIconButton size={size} src={require("../assets/FacebookSquare.png")} 
          url={"https://www.facebook.com/SanPedroAssociation.org/"} />
        <SquareIconButton size={size} src={require("../assets/InstagramSquare.jpg")} 
          url={"https://www.instagram.com/sanpedroassociation/"} />
        <SquareIconButton size={size} src={require("../assets/GoogleMapsSquare.png")} 
          url={"https://www.google.com/maps/place/San+Pedro+Park/@38.5938549,-121.5464816,17z/data=!3m1!4b1!4m6!3m5!1s0x809ad4240ec043a7:0xdf79381dc53a7537!8m2!3d38.5938507!4d-121.5439067!16s%2Fg%2F11bt_grvtd?entry=ttu"} />
      </div>
    )
  }

export default function TopBar() {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    if (isMobile) {
      return (
        <div
          id="top-bar"
          style={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: theme.palette.primary.main,
            alignItems: "center",
            gap: 10,
            padding: "10px 16px"
          }}>
          <img src={require("../assets/Festa.jpg")} alt="San Pedro Festa"
            style={{ height: 110, width: "auto", borderRadius: 16, objectFit: "contain" }} />
          <Typography style={{ color: theme.palette.primary.contrastText, textAlign: "center", marginTop: 4, marginBottom: 4, fontWeight: 700, fontFamily: "'Playfair Display', serif" }} variant="h3">
            <b>San Pedro Association</b>
          </Typography>
          <Logos size={38} gap={10} />
        </div>
      )
    }

    return (
      <div
        id="top-bar"
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: theme.palette.primary.main,
          alignItems: "center",
          padding: "10px 88px"
        }}>
        {/* Left: logo */}
        <div style={{ flex: 1, display: "flex", justifyContent: "flex-start" }}>
          <img src={require("../assets/Festa.jpg")} alt="San Pedro Festa"
            style={{ height: 160, width: "auto", borderRadius: 20, objectFit: "contain" }} />
        </div>
        {/* Center: title */}
        <div style={{
          flex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
          paddingLeft: 56,
          paddingRight: 56
        }}>
          <Typography style={{
            color: theme.palette.primary.contrastText,
            textAlign: "center",
            whiteSpace: "nowrap",
            lineHeight: 1.05,
            fontWeight: 700,
            fontSize: "3.85rem",
            fontFamily: "'Playfair Display', serif"
          }} variant="h1">
            <b>San Pedro Association</b>
          </Typography>
          <Logos size={40} gap={10} />
        </div>
        {/* Right: spacer keeps center block visually centered */}
        <div style={{ flex: 1 }}>
        </div>
      </div>
    )
  }